import React from 'react';

// Components
import CategoryCard from './CategoryCard';

const CategoryCards = ({ categories }) => (
  <div className="resource-library-categories">
    {
      categories.map((category, index) => (
        <CategoryCard key={index} category={category} />
      ))
    }
  </div>
)

export default CategoryCards



// WEBPACK FOOTER //
// ./src/components/ResourceLibrary/CategoryCards.js